function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var TackFilled = function TackFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M15.244 2.47a.75.75 0 0 1 1.06 0l1.153 1.152.009.009 3.484 3.484.009.009 1.152 1.152a.75.75 0 0 1-1.06 1.06l-.515-.514-2.196 3.295c-.37.555-.564 1.202-.793 1.97l-.117.387c-.316 1.032-.88 1.993-1.439 2.732-.28.371-.568.697-.834.957-.254.247-.53.475-.79.605a.75.75 0 0 1-.865-.14l-3.534-3.535L3.53 21.53a.75.75 0 1 1-1.06-1.06l6.437-6.438-3.534-3.534a.75.75 0 0 1-.055-.999c1.535-1.92 3.187-2.774 4.528-3.087.272-.063.546-.118.808-.171l.03-.006c.275-.055.537-.108.793-.169.514-.122.966-.267 1.361-.486l2.864-1.591-.458-.459a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M15.244 2.47a.75.75 0 0 1 1.06 0l1.153 1.152.009.009 3.484 3.484.009.009 1.152 1.152a.75.75 0 0 1-1.06 1.06l-.515-.514-2.196 3.295c-.37.555-.564 1.202-.793 1.97l-.117.387c-.316 1.032-.88 1.993-1.439 2.732-.28.371-.568.697-.834.957-.254.247-.53.475-.79.605a.75.75 0 0 1-.865-.14l-3.534-3.535L3.53 21.53a.75.75 0 1 1-1.06-1.06l6.437-6.438-3.534-3.534a.75.75 0 0 1-.055-.999c1.535-1.92 3.187-2.774 4.528-3.087.272-.063.546-.118.808-.171l.03-.006c.275-.055.537-.108.793-.169.514-.122.966-.267 1.361-.486l2.864-1.591-.458-.459a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  }));
};
export default TackFilled;
TackFilled.displayName = 'TackFilled';